import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Table, Button, Form, Badge, Modal } from 'react-bootstrap';
import moment from 'moment';
import { toast } from 'react-toastify';
import { Put, DeleteSingle } from '../../../../utils/httpProvider';
import { LICHHOCTHUCHANH_API } from '../../../../utils/apiUrl';
import { messageToast } from '../../../../utils/define';
import DetailedScheduleListView from './DetailedScheduleListView';
import AdminMatrixView from '../AdminMatrixView';
import StudentTimelineView from '../StudentTimelineView';
import InstructorAgendaView from '../InstructorAgendaView';
import DepartmentMappingModal from './DepartmentMappingModal';
import ImportScheduleWizardModal from './ImportScheduleWizardModal';
import { ConfirmModal } from '../../../../modules/modal/ConfirmModal';
import DiemDanhTab from './DiemDanhTab';
import AttendanceReportTab from './AttendanceReportTab';

const ScheduleTab = ({
    contractId,
    donViData,
    nganhDaoTaoData,
    studentsData,
    tutorsData,
    currentUserSub,
    currentUserRoles,
    isStudentUser,
    isInstructorUser,
    scheduleData,
    isScheduleLoading,
    refetchSchedule,
    adminRequestsData,
    isAdminRequestsLoading,
    mappingData,
    refetchMappings
}) => {
    const [viewMode, setViewMode] = useState('list'); // 'list' | 'matrix' | 'student' | 'instructor' | 'adminRequests'
    const [studentFilter, setStudentFilter] = useState('');
    const [tutorFilter, setTutorFilter] = useState('');
    const [selectedStudentId, setSelectedStudentId] = useState('');
    const [selectedInstructorId, setSelectedInstructorId] = useState('');

    // Modal state for editing schedule row
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingItem, setEditingItem] = useState(null);

    // Modals visibility states
    const [showMappingModal, setShowMappingModal] = useState(false);
    const [showImportWizard, setShowImportWizard] = useState(false);

    // Delete confirmation state
    const [idWantDelete, setIdWantDelete] = useState('');
    const [confirmDelMessage, setConfirmDelMessage] = useState('');
    const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false);

    useEffect(() => {
        if (isStudentUser && currentUserSub) {
            setSelectedStudentId(currentUserSub);
        } else if (studentsData && studentsData.length > 0 && !selectedStudentId) {
            setSelectedStudentId(studentsData[0].id || studentsData[0].accountId);
        }
    }, [studentsData, selectedStudentId, isStudentUser, currentUserSub]);

    useEffect(() => {
        if (isInstructorUser && currentUserSub) {
            setSelectedInstructorId(currentUserSub);
        } else if (tutorsData && tutorsData.length > 0 && !selectedInstructorId) {
            setSelectedInstructorId(tutorsData[0].id || tutorsData[0].accountId);
        }
    }, [tutorsData, selectedInstructorId, isInstructorUser, currentUserSub]);

    // --- HANDLE EDIT ROW ---
    const handleOpenEdit = (record) => {
        setEditingItem({ ...record });
        setShowEditModal(true);
    };

    const handleSaveEdit = async () => {
        if (!editingItem) return;
        try {
            await Put(`${LICHHOCTHUCHANH_API.UPDATE_ITEM}`, editingItem.id || editingItem.Id, editingItem);
            toast.success(messageToast.messageToastUpdateSuccess);
            setShowEditModal(false);
            refetchSchedule();
        } catch (err) {
            toast.error(err?.message || 'Không thể cập nhật lịch học.');
        }
    };

    // --- HANDLE DELETE CONFIRMATION ---
    const handleDeleteRow = (recordId) => {
        setIdWantDelete(recordId);
        setConfirmDelMessage('Bạn có chắc chắn muốn xóa dòng lịch học này khỏi kế hoạch?');
        setOpenConfirmDeleteModal(true);
    };

    const handleConfirmDelete = async () => {
        if (!idWantDelete) return;
        try {
            await DeleteSingle(`${LICHHOCTHUCHANH_API.DELETE_ITEM}`, idWantDelete);
            toast.success(messageToast.messageToastDeleteSuccess);
            refetchSchedule();
        } catch (err) {
            toast.error(err?.message || "Không thể thực hiện thao tác xóa.");
        } finally {
            setOpenConfirmDeleteModal(false);
            setIdWantDelete('');
        }
    };

    return (
        <div className="p-4">
            <div className="mb-3">
                <h5 className="font-weight-bold text-dark mb-1">Kế hoạch & Lịch thực hành lâm sàng chi tiết</h5>
            </div>
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 p-2 bg-white rounded-lg border shadow-xs" style={{ gap: '15px' }}>
                {/* VIEW TOGGLE */}
                <div className="btn-group shadow-xs" role="group">
                    <Button
                        variant={viewMode === 'list' ? 'primary' : 'outline-primary'}
                        size="sm"
                        onClick={() => setViewMode('list')}
                        style={{ borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px', whiteSpace: 'nowrap', padding: '8px 16px', fontWeight: '500' }}
                    >
                        <i className="fas fa-list mr-1"></i> Chi tiết
                    </Button>

                    <Button
                        variant={viewMode === 'matrix' ? 'primary' : 'outline-primary'}
                        size="sm"
                        onClick={() => setViewMode('matrix')}
                        style={{ borderRadius: '0', whiteSpace: 'nowrap', padding: '8px 16px', fontWeight: '500' }}
                    >
                        <i className="fas fa-table mr-1"></i> Ma trận
                    </Button>
                    <Button
                        variant={viewMode === 'student' ? 'primary' : 'outline-primary'}
                        size="sm"
                        onClick={() => setViewMode('student')}
                        style={{ borderRadius: '0', whiteSpace: 'nowrap', padding: '8px 16px', fontWeight: '500' }}
                    >
                        <i className="fas fa-graduation-cap mr-1"></i> Lịch Học viên
                    </Button>
                    <Button
                        variant={viewMode === 'instructor' ? 'primary' : 'outline-primary'}
                        size="sm"
                        onClick={() => setViewMode('instructor')}
                        style={{ borderRadius: '0', whiteSpace: 'nowrap', padding: '8px 16px', fontWeight: '500' }}
                    >
                        <i className="fas fa-user-tie mr-1"></i> Lịch Giảng viên
                    </Button>
                    <Button
                        variant={viewMode === 'diemdanh' ? 'primary' : 'outline-primary'}
                        size="sm"
                        onClick={() => setViewMode('diemdanh')}
                        style={{ borderRadius: '0', whiteSpace: 'nowrap', padding: '8px 16px', fontWeight: '500' }}
                    >
                        <i className="fas fa-check-double mr-1"></i> Điểm danh
                    </Button>
                    <Button
                        variant={viewMode === 'baocaodiemdanh' ? 'primary' : 'outline-primary'}
                        size="sm"
                        onClick={() => setViewMode('baocaodiemdanh')}
                        style={{ borderTopRightRadius: '8px', borderBottomRightRadius: '8px', whiteSpace: 'nowrap', padding: '8px 16px', fontWeight: '500' }}
                    >
                        <i className="fas fa-file-chart-line mr-1"></i> Báo cáo điểm danh
                    </Button>
                </div>

                <div className="d-flex align-items-center flex-wrap" style={{ gap: '10px' }}>
                    <Button
                        variant="outline-primary"
                        className="shadow-sm"
                        style={{ borderRadius: '8px', padding: '8px 16px', whiteSpace: 'nowrap', fontWeight: '500' }}
                        onClick={() => setShowMappingModal(true)}
                    >
                        <i className="fas fa-map-signs mr-2"></i> Cấu hình ánh xạ khoa
                    </Button>

                    <Button
                        variant="primary"
                        className="shadow-sm"
                        style={{ borderRadius: '8px', padding: '8px 16px', whiteSpace: 'nowrap', fontWeight: '500' }}
                        onClick={() => setShowImportWizard(true)}
                        disabled={!contractId}
                    >
                        <i className="fas fa-file-excel mr-2"></i> Nhập lịch thực hành từ Excel
                    </Button>
                </div>
            </div>

            {/* FILTERS PANEL */}
            {scheduleData && scheduleData.length > 0 && (
                <Row className="mb-3 bg-light p-3 rounded-lg border mx-0 align-items-center">
                    <Col md={1} className="font-weight-bold text-muted small text-uppercase mb-2 mb-md-0">
                        <i className="fas fa-filter mr-1"></i> Lọc:
                    </Col>
                    <Col md={viewMode === 'student' || viewMode === 'instructor' ? 3 : 5} className="mb-2 mb-md-0">
                        <Form.Control
                            type="text"
                            placeholder="Tên học viên..."
                            size="sm"
                            value={studentFilter}
                            onChange={(e) => setStudentFilter(e.target.value)}
                            style={{ borderRadius: '6px' }}
                        />
                    </Col>
                    <Col md={viewMode === 'student' || viewMode === 'instructor' ? 3 : 5} className="mb-2 mb-md-0">
                        <Form.Control
                            type="text"
                            placeholder="Tên giảng viên..."
                            size="sm"
                            value={tutorFilter}
                            onChange={(e) => setTutorFilter(e.target.value)}
                            style={{ borderRadius: '6px' }}
                        />
                    </Col>
                    {viewMode === 'student' && (
                        <Col md={4} className="mb-2 mb-md-0 d-flex align-items-center">
                            <span className="small text-dark font-weight-bold mr-2 text-nowrap" style={{ letterSpacing: '0.3px' }}>HỌC VIÊN:</span>
                            <Form.Control
                                as="select"
                                size="sm"
                                value={selectedStudentId}
                                onChange={(e) => setSelectedStudentId(e.target.value)}
                                style={{ borderRadius: '6px', borderColor: '#cbd5e1', height: '31px' }}
                                disabled={isStudentUser}
                            >
                                {(!studentsData || studentsData.length === 0) ? (
                                    <option value="">Không có học viên</option>
                                ) : (
                                    studentsData
                                        .filter(s => !isStudentUser || s.id === currentUserSub)
                                        .map(s => (
                                            <option key={s.id || s.accountId} value={s.id || s.accountId}>{s.fullName}</option>
                                        ))
                                )}
                            </Form.Control>
                        </Col>
                    )}
                    {viewMode === 'instructor' && (
                        <Col md={4} className="mb-2 mb-md-0 d-flex align-items-center">
                            <span className="small text-dark font-weight-bold mr-2 text-nowrap" style={{ letterSpacing: '0.3px' }}>GIẢNG VIÊN:</span>
                            <Form.Control
                                as="select"
                                size="sm"
                                value={selectedInstructorId}
                                onChange={(e) => setSelectedInstructorId(e.target.value)}
                                style={{ borderRadius: '6px', borderColor: '#cbd5e1', height: '31px' }}
                                disabled={isInstructorUser}
                            >
                                {(!tutorsData || tutorsData.length === 0) ? (
                                    <option value="">Không có giảng viên</option>
                                ) : (
                                    tutorsData
                                        .filter(t => !isInstructorUser || t.id === currentUserSub)
                                        .map(t => (
                                            <option key={t.id || t.accountId} value={t.id || t.accountId}>{t.fullName}</option>
                                        ))
                                )}
                            </Form.Control>
                        </Col>
                    )}
                    {(studentFilter || tutorFilter) && (
                        <Col md={1} className="text-right">
                            <Button variant="link" size="sm" className="p-0 text-danger text-decoration-none font-weight-bold" onClick={() => { setStudentFilter(''); setTutorFilter(''); }}>
                                Xóa lọc
                            </Button>
                        </Col>
                    )}
                </Row>
            )}

            {!contractId ? (
                <div className="alert alert-warning shadow-sm mb-0">
                    <i className="fas fa-exclamation-triangle mr-2"></i>
                    Khóa học thực hành này chưa được liên kết với Hợp đồng chi tiết. Vui lòng liên kết Hợp đồng chi tiết để có thể nhập và hiển thị lịch đào tạo thực tập lâm sàng.
                </div>
            ) : isScheduleLoading ? (
                <div className="text-center py-4">
                    <div className="spinner-border text-primary spinner-border-sm mr-2"></div> Đang tải lịch học...
                </div>
            ) : scheduleData && scheduleData.length > 0 ? (
                viewMode === 'list' ? (
                    <DetailedScheduleListView
                        scheduleData={scheduleData}
                        isScheduleLoading={isScheduleLoading}
                        studentFilter={studentFilter}
                        tutorFilter={tutorFilter}
                        handleOpenEdit={handleOpenEdit}
                        handleDeleteRow={handleDeleteRow}
                    />
                ) : viewMode === 'matrix' ? (
                    <AdminMatrixView contractId={contractId} />
                ) : viewMode === 'student' ? (
                    <StudentTimelineView contractId={contractId} selectedStudentId={selectedStudentId} />
                ) : viewMode === 'instructor' ? (
                    <InstructorAgendaView 
                        contractId={contractId} 
                        selectedInstructorId={selectedInstructorId} 
                        onNavigateToAttendance={() => setViewMode('diemdanh')}
                    />
                ) : viewMode === 'diemdanh' ? (
                    <DiemDanhTab contractId={contractId} />
                ) : viewMode === 'baocaodiemdanh' ? (
                    <AttendanceReportTab contractId={contractId} />
                ) : null
            ) : (
                <div className="text-center py-5 text-muted border rounded-lg bg-light">
                    <i className="far fa-calendar-times fa-3x mb-3 text-muted" style={{ opacity: 0.5 }}></i>
                    <h5>Chưa có lịch thực hành lâm sàng chi tiết</h5>
                    <p className="small mb-0">Vui lòng tải tệp Excel kế hoạch để phân tách lịch học.</p>
                </div>
            )}

            {/* EDIT SCHEDULE MODAL */}
            {editingItem && (
                <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered scrollable>
                    <Modal.Header closeButton className="border-bottom-0 pb-0">
                        <Modal.Title className="font-weight-bold">Chỉnh sửa Lịch thực hành đợt</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pt-2">
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label className="text-muted small font-weight-bold">Học viên <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    as="select"
                                    value={editingItem.hopDongChiTietHocVien?.accountId || editingItem.hopDongChiTietHocVienId || ''}
                                    onChange={(e) => {
                                        const selectedAccountId = e.target.value;
                                        const student = (studentsData || []).find(s => (s.accountId || s.id) === selectedAccountId);
                                        if (student) {
                                            setEditingItem({
                                                ...editingItem,
                                                hopDongChiTietHocVien: {
                                                    id: editingItem.hopDongChiTietHocVien?.id || editingItem.hopDongChiTietHocVienId,
                                                    accountId: selectedAccountId
                                                },
                                                hocVienTen: student.fullName
                                            });
                                        }
                                    }}
                                    style={{ borderRadius: '8px' }}
                                >
                                    <option value="">-- Chọn học viên --</option>
                                    {(studentsData || []).map(s => (
                                        <option key={s.accountId || s.id} value={s.accountId || s.id}>
                                            {s.fullName} ({s.pseudonym || s.identityCard || 'Không có mã'})
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>

                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="text-muted small font-weight-bold">Ngày bắt đầu đợt <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={editingItem.ngayBatDau ? moment(editingItem.ngayBatDau).format('YYYY-MM-DD') : ''}
                                            onChange={(e) => setEditingItem({ ...editingItem, ngayBatDau: e.target.value })}
                                            style={{ borderRadius: '8px' }}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="text-muted small font-weight-bold">Ngày kết thúc đợt <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={editingItem.ngayKetThuc ? moment(editingItem.ngayKetThuc).format('YYYY-MM-DD') : ''}
                                            onChange={(e) => setEditingItem({ ...editingItem, ngayKetThuc: e.target.value })}
                                            style={{ borderRadius: '8px' }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Form.Group className="mb-3">
                                <Form.Label className="text-muted small">Ngày nghỉ theo lịch (nếu có)</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={editingItem.ngayNghiTheoLich ? moment(editingItem.ngayNghiTheoLich).format('YYYY-MM-DD') : ''}
                                    onChange={(e) => setEditingItem({ ...editingItem, ngayNghiTheoLich: e.target.value || null })}
                                    style={{ borderRadius: '8px' }}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="text-muted small">Trình độ (e.g. Năm 2, Năm 3...)</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Năm 2..."
                                    value={editingItem.trinhDo || editingItem.TrinhDo || ''}
                                    onChange={(e) => setEditingItem({ ...editingItem, trinhDo: e.target.value, TrinhDo: e.target.value })}
                                    style={{ borderRadius: '8px' }}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="text-muted small font-weight-bold">Đơn vị / Khoa</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={editingItem.donViId || ''}
                                    onChange={(e) => {
                                        const selectedId = e.target.value;
                                        const matched = (donViData || []).find(d => d.id === selectedId);
                                        setEditingItem({
                                            ...editingItem,
                                            donViId: selectedId,
                                            donVi: matched ? (matched.tenDonVi || matched.TenDonVi) : ''
                                        });
                                    }}
                                    style={{ borderRadius: '8px' }}
                                >
                                    <option value="">-- Chọn Khoa luân chuyển --</option>
                                    {(donViData || []).map(d => (
                                        <option key={d.id} value={d.id}>
                                            {d.tenDonVi || d.TenDonVi}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="text-muted small font-weight-bold">Chuyên ngành đào tạo</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={editingItem.nganhDaoTaoId || ''}
                                    onChange={(e) => setEditingItem({ ...editingItem, nganhDaoTaoId: e.target.value })}
                                    style={{ borderRadius: '8px' }}
                                >
                                    <option value="">-- Chọn chuyên ngành --</option>
                                    {(nganhDaoTaoData || []).map(n => (
                                        <option key={n.id} value={n.id}>
                                            {n.tenNganh || n.TenNganh}
                                        </option>
                                    ))}
                                </Form.Control>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="text-muted small font-weight-bold">Giảng viên hướng dẫn (GVLS)</Form.Label>
                                <div className="border p-3 rounded-lg bg-light" style={{ maxHeight: '180px', overflowY: 'auto' }}>
                                    {(tutorsData || []).map(tutor => {
                                        const currentGvs = editingItem.lichHocThucHanh_GiangViens || editingItem.LichHocThucHanh_GiangViens || [];
                                        const isChecked = currentGvs.some(g => (g.hopDongChiTietGiangVienId || g.HopDongChiTietGiangVienId) === (tutor.id || tutor.accountId));
                                        return (
                                            <Form.Check
                                                key={tutor.id || tutor.accountId}
                                                type="checkbox"
                                                id={`tutor-chk-${tutor.id || tutor.accountId}`}
                                                label={tutor.fullName}
                                                checked={isChecked}
                                                onChange={(e) => {
                                                    let newList = [...currentGvs];
                                                    if (e.target.checked) {
                                                        newList.push({
                                                            hopDongChiTietGiangVienId: tutor.id || tutor.accountId,
                                                            giangVienTen: tutor.fullName,
                                                            laGiangVienChinh: newList.length === 0
                                                        });
                                                    } else {
                                                        newList = newList.filter(g => (g.hopDongChiTietGiangVienId || g.HopDongChiTietGiangVienId) !== (tutor.id || tutor.accountId));
                                                    }
                                                    if (newList.length > 0 && !newList.some(g => g.laGiangVienChinh || g.LaGiangVienChinh)) {
                                                        newList[0].laGiangVienChinh = true;
                                                    }
                                                    setEditingItem({
                                                        ...editingItem,
                                                        lichHocThucHanh_GiangViens: newList,
                                                        LichHocThucHanh_GiangViens: newList
                                                    });
                                                }}
                                                className="mb-2"
                                            />
                                        );
                                    })}
                                    {(tutorsData || []).length === 0 && (
                                        <div className="text-muted small text-center py-2">Danh sách roster giảng viên trống.</div>
                                    )}
                                </div>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="text-muted small">Ghi chú / Nhận xét lỗi</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    placeholder="Nội dung ghi chú..."
                                    value={editingItem.ghiChu || editingItem.GhiChu || ''}
                                    onChange={(e) => setEditingItem({ ...editingItem, ghiChu: e.target.value, GhiChu: e.target.value })}
                                    style={{ borderRadius: '8px' }}
                                />
                            </Form.Group>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer className="border-top-0 pt-0">
                        <Button variant="light" onClick={() => setShowEditModal(false)} style={{ borderRadius: '8px' }}>
                            Hủy bỏ
                        </Button>
                        <Button variant="primary" onClick={handleSaveEdit} style={{ borderRadius: '8px' }}>
                            Lưu thay đổi
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}

            {/* DEPARTMENT MAPPING MODAL */}
            <DepartmentMappingModal
                show={showMappingModal}
                onHide={() => setShowMappingModal(false)}
                donViData={donViData}
                mappingData={mappingData}
                refetchMappings={refetchMappings}
            />

            {/* SCHEDULE IMPORT WIZARD MODAL */}
            <ImportScheduleWizardModal
                show={showImportWizard}
                onHide={() => setShowImportWizard(false)}
                contractId={contractId}
                donViData={donViData}
                nganhDaoTaoData={nganhDaoTaoData}
                studentsData={studentsData}
                tutorsData={tutorsData}
                refetchSchedule={refetchSchedule}
            />

            {/* DELETE CONFIRMATION MODAL */}
            <ConfirmModal
                show={openConfirmDeleteModal}
                onHide={() => setOpenConfirmDeleteModal(false)}
                onConfirm={handleConfirmDelete}
                message={confirmDelMessage}
            />
        </div>
    );
};

export default ScheduleTab;
